export const formatDateBR = (dateString) => {
  if (!dateString) return "";

  try {
    const dateOnly = dateString.split("T")[0];
    const [year, month, day] = dateOnly.split("-");
    
    if (!year || !month || !day) {
      return dateString;
    }

    return `${day.padStart(2, "0")}/${month.padStart(2, "0")}/${year}`;
  } catch (error) {
    console.error("Erro ao formatar data:", dateString, error);
    return dateString;
  }
};

